/**
 * RX fix 30/09 — garde-fou carrousel (erreurs Clarity
 * "this.slides[this.currentIndex].firstElementChild").
 * Le CarouselSlider actif est celui embarqué dans main.js (assets/slider.js n'est
 * pas chargé). On patche son prototype : index borné + hauteur dynamique protégée.
 * Chargé en defer juste après main.js.
 */
(function () {
  var C = window.customElements && customElements.get('carousel-slider');
  if (!C || C.prototype.__rxGuard) return;
  var p = C.prototype;
  p.__rxGuard = true;

  function clamp(el) {
    var n = el.slides ? el.slides.length : 0;
    var i = el.currentIndex;
    if (typeof i !== 'number' || !isFinite(i) || i < 0) i = 0;
    if (n && i > n - 1) i = n - 1;
    el.currentIndex = i;
  }

  p.updateDynamicHeight = function () {
    clamp(this);
    var slide = this.slides && this.slides[this.currentIndex];
    var content = slide && slide.firstElementChild;
    if (!content) return;
    this.style.setProperty('--current-slide-height', content.clientHeight + 'px');
  };

  p.handleScroll = function () {
    if (this.gridWidth !== this.grid.clientWidth) this.handleResize();

    var previousIndex = this.currentIndex;
    this.currentIndex = this.slideSpan
      ? Math.round(Math.abs(this.slider.scrollLeft) / this.slideSpan)
      : 0;
    clamp(this);

    if (this.nav) this.setButtonStates();
    if (this.dataset.dynamicHeight === 'true') this.updateDynamicHeight();

    if (this.dataset.dispatchEvents === 'true' && previousIndex !== this.currentIndex) {
      this.dispatchEvent(new CustomEvent('on:carousel-slider:select', {
        bubbles: true,
        detail: { index: this.currentIndex, slide: this.slides[this.currentIndex] }
      }));
    }
  };

  // Carrousels déjà initialisés : re-lier le handler de scroll sur la version patchée.
  document.querySelectorAll('carousel-slider[loaded]').forEach(function (el) {
    try { if (el.slider && el.removeListeners) { el.removeListeners(); el.addListeners(); } } catch (e) {}
  });
})();
